import { render, staticRenderFns } from "./casecontent.vue?vue&type=template&id=59faca38&scoped=true&"
import script from "./casecontent.vue?vue&type=script&lang=js&"
export * from "./casecontent.vue?vue&type=script&lang=js&"
import style0 from "./casecontent.vue?vue&type=style&index=0&id=59faca38&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59faca38",
  null
  
)

export default component.exports